import { motion } from "framer-motion";
import Images from "../../utils/Images";

const partnerLogos = [
  Images.sunu,
  Images.sunu,
  Images.sunu,
  Images.sunu,
  Images.sunu,
];

function PartnerCard({ src, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.4 }}
      transition={{ duration: 0.5, delay: index * 0.05 }}
      whileHover={{ y: -4, scale: 1.03 }}
      className="overflow-hidden relative bg-white rounded-2xl border shadow-sm group border-emerald-900/10"
      style={{ aspectRatio: "5 / 4" }}
    >
      {/* Subtle sheen */}
      <div className="absolute inset-0 bg-gradient-to-r from-transparent to-transparent opacity-0 transition-all duration-700 -translate-x-full pointer-events-none via-white/30 group-hover:opacity-100 group-hover:translate-x-0" />
      <div className="flex justify-center items-center p-6 w-full h-full">
        {src ? (
          <img
            src={src}
            alt="Insurance partner"
            className="object-contain w-auto h-20 opacity-90 grayscale transition-all duration-300 group-hover:grayscale-0 group-hover:opacity-100"
          />
        ) : (
          <div className="w-24 h-10 bg-emerald-100 rounded-md" />
        )}
      </div>
    </motion.div>
  );
}

export default function Partners() {
  return (
    <section className="relative py-14 md:py-18 bg-emerald-50/60">
      <div className="px-6 mx-auto max-w-6xl">
        <div className="text-center">
          <div className="inline-block relative">
            <h3 className="text-xl font-extrabold text-gray-900 md:text-2xl">
              Trusted Insurance Partners
            </h3>
            <span className="absolute -bottom-1 left-1/2 w-40 h-2 rounded-full -translate-x-1/2 bg-emerald-300/70" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4 mx-auto mt-8 max-w-5xl sm:grid-cols-3 md:mt-10 md:grid-cols-5">
          {partnerLogos.map((logo, i) => (
            <PartnerCard key={i} src={logo} index={i} />)
          )}
        </div>
      </div>
    </section>
  );
}


